<template>
  <div class="realWrap">
    <div class="container">
      <div class="header">
        <div class="col handle">代理商</div>
        <div class="col name">设备名称</div>
        <div class="col createTime">出货日期</div>
        <div class="col name">报警日期</div>
        <div class="col name">窜货地</div>
        <div class="col name">操作</div>
      </div>

      <div v-if="displayData && displayData.length > 0" class="swiper-container vertical-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide swiper-item" v-for="(item, index) in displayData" :key="index">
            <div class="col handle">{{ item.dealerName || "-" }}</div>
            <div class="col name">{{ item.deviceName || "-" }}</div>
            <div class="col createTime">{{ item.createTime || "-" }}</div>
            <div class="col createTime">{{ item.updateTime || "-" }}</div>
            <div class="col createTime">{{ item.fleeingAddress || "-" }}</div>
            <div class="col createTime"><el-button type="primary" @click="lookGuiji(item)">查看轨迹</el-button></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from "swiper";
  // import "swiper/css/swiper.css";

  export default {
    components: {},
    props: {
      realData: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },
    data() {
      return {
        swiperInstance: null,
      };
    },
    computed: {
      displayData() {
        return (this.realData || []).filter(
          (item) => this.hasDisplayText(item.dealerName) && this.hasDisplayText(item.deviceName)
        );
      },
    },
    watch: {
      displayData: {
        handler(newData) {
          if (newData.length > 0) {
            if (!this.swiperInstance) {
              this.initSwiper();
            } else {
              this.swiperInstance.update();
            }
          }
        },
        deep: true,
      },
    },
    mounted() {
      setTimeout(() => {
        this.initSwiper();
      }, 3000);
    },
    methods: {
      hasDisplayText(val) {
        return val != null && String(val).trim() !== "" && String(val).trim() !== "-";
      },
      initSwiper() {
        this.swiperInstance = new Swiper(".vertical-swiper", {
          direction: "vertical", // 设置轮播方向为垂直方向
          slidesPerView: 10, // 每次显示 10 条
          slidesPerGroup: 1, // 每次轮播 1 条
          loop: true, // 开启循环轮播
          autoplay: {
            delay: 2000, // 轮播间隔时间为 2 秒
            disableOnInteraction: true, // 用户交互后不停止自动轮播
          },
        });
      },
      lookGuiji(item) {
        // 不传时间，设备轨迹页按最后定位时间往前推7天
        this.$router.push({
          path: '/gps/gj',
          query: {
            deviceId: item.id,
            dealerId: item.dealerId
          }
        });
      }
    },
  };
</script>
<style lang="scss">
  .container {
    width: 1700px;
    font-family: "微软雅黑", sans-serif;
    user-select: none;
  }

  /* 标题栏 */
  .header {
    display: flex;
    background-color: #f3f6fa;
    font-weight: bold;
    padding: 8px 0;
    font-size: 14px;
  }

  /* 列宽 */
  .col {
    padding: 0 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 28px;
    box-sizing: border-box;
    font-size: 14px;
  }

  .header .col:last-child {
    border-right: none;
  }

  .name {
    flex: 2.5;
  }

  .handle {
    flex: 2.5;
  }

  .createTime {
    flex: 2.5;
  }

  .desc {
    flex: 3.5;
  }

  .img {
    flex: 1.8;

    img {
      width: 200px;
      height: 200px;
    }
  }

  .verticalSwiper {
    height: 300px;
    /* 10 条，每条30px */
    overflow: hidden;
  }

  /* swiper-wrapper 保持默认block，不要用flex */
  .swiper-wrapper {
    display: block !important;
  }

  /* swiper-slide 固定高度 */
  .swiper-item {
    display: flex !important;
    font-size: 13px;
    color: #333;
    background-color: #fff;
    border-bottom: 1px solid #eee;
    line-height: 40px;
    height: 40px !important;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .swiper-item .col {
    padding: 0 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .swiper-item .col:last-child {
    border-right: none;
  }

  .chart-title {
    text-align: center;
    margin-bottom: 30px;
    font-weight: 600;
    font-size: 20px;
  }

  .vertical-swiper {
    height: 400px;
    overflow: hidden;
  }
</style>